import { useCallback } from 'react';

import { useTour } from './TourProvider';

export function useTourAnchor<TElement extends HTMLElement = HTMLElement>(anchorId: string) {
  const { registerAnchor } = useTour();

  return useCallback(
    (node: TElement | null) => {
      registerAnchor(anchorId, node);
    },
    [anchorId, registerAnchor]
  );
}
